import type { SessionResult } from '../types'
import { formatDuration } from '../utils/session'

function drawWrappedText(
  context: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  maxWidth: number,
  lineHeight: number,
): number {
  const words = text.split(' ')
  let line = ''
  let currentY = y
  for (const word of words) {
    const test = `${line}${word} `
    if (context.measureText(test).width > maxWidth && line) {
      context.fillText(line.trim(), x, currentY)
      line = `${word} `
      currentY += lineHeight
    } else {
      line = test
    }
  }
  context.fillText(line.trim(), x, currentY)
  return currentY
}

export function downloadResultImage(result: SessionResult): void {
  const canvas = document.createElement('canvas')
  canvas.width = 1200
  canvas.height = 1500
  const context = canvas.getContext('2d')
  if (!context) return

  context.fillStyle = '#f6f0e7'
  context.fillRect(0, 0, canvas.width, canvas.height)
  context.fillStyle = '#0b4f8a'
  context.fillRect(0, 0, canvas.width, 180)
  context.fillStyle = '#ffffff'
  context.font = 'bold 52px Arial'
  context.fillText('Laboratorio de Historia – 6° Básico', 70, 95)
  context.font = '30px Arial'
  context.fillText('Instituto de Humanidades Luis Campino', 70, 145)

  context.fillStyle = '#16202a'
  context.font = 'bold 42px Arial'
  context.fillText(result.student.name, 70, 265)
  context.font = '30px Arial'
  context.fillText(`${result.student.course} · ${new Date(result.timestamp).toLocaleDateString('es-CL')}`, 70, 315)

  context.fillStyle = '#ffffff'
  context.strokeStyle = '#0b4f8a'
  context.lineWidth = 4
  context.fillRect(70, 370, 1060, 250)
  context.strokeRect(70, 370, 1060, 250)
  context.fillStyle = '#0b4f8a'
  context.font = 'bold 90px Arial'
  context.fillText(`${result.percentage}%`, 110, 515)
  context.fillStyle = '#16202a'
  context.font = '32px Arial'
  context.fillText(`${result.correctCount} respuestas correctas`, 410, 460)
  context.fillText(`${result.incorrectCount} respuestas por reforzar`, 410, 510)
  context.fillText(`${result.attempts} intentos · ${formatDuration(result.durationSeconds)}`, 410, 560)

  context.font = 'bold 38px Arial'
  context.fillText('Resultados por Objetivo de Aprendizaje', 70, 700)
  let y = 765
  Object.entries(result.resultsByOA).forEach(([oa, item]) => {
    context.fillStyle = '#dce8f2'
    context.fillRect(70, y - 40, 1060, 75)
    context.fillStyle = '#16202a'
    context.font = 'bold 30px Arial'
    context.fillText(oa, 95, y + 8)
    context.font = '30px Arial'
    context.fillText(`${item.percentage}% (${item.correct} de ${item.total})`, 300, y + 8)
    y += 100
  })

  context.font = 'bold 38px Arial'
  context.fillText('Sugerencia de estudio', 70, 1110)
  context.font = '30px Arial'
  drawWrappedText(context, result.recommendation, 70, 1175, 1050, 44)

  context.font = '24px Arial'
  context.fillStyle = '#495057'
  context.fillText('Este comprobante no incluye respuestas ni códigos de acceso.', 70, 1430)

  const link = document.createElement('a')
  link.download = `resultado-${result.student.name.toLowerCase().replace(/\s+/g, '-')}.png`
  link.href = canvas.toDataURL('image/png')
  link.click()
}
